import { IntegrationKey } from 'entities/Integrations'
import { nangoConnect, nangoReconnect } from 'entities/Integrations/providers/Nango'
import { useEntitiesContext } from 'entities/EntitiesExport'

type IUseLiveDocumentsAccessLostParams = {
  hasGoogleSheetLiveDocument: boolean
  hasGoogleDocLiveDocument: boolean
  hasAccessLostDocument?: boolean
}

export const useLiveDocumentsAccessLost = ({
  hasGoogleSheetLiveDocument,
  hasGoogleDocLiveDocument,
  hasAccessLostDocument = false,
}: IUseLiveDocumentsAccessLostParams) => {
  const entities = useEntitiesContext()

  const gsheetsIntegration = entities.integrationsStore.getIntegration(IntegrationKey.google_sheet)
  const gdocsIntegration = entities.integrationsStore.getIntegration(IntegrationKey.google_doc)

  const isGoogleSheetsLost = Boolean(
    hasGoogleSheetLiveDocument &&
      (gsheetsIntegration?.connected || gsheetsIntegration?.disconnected) &&
      !gsheetsIntegration.isConnected
  )
  const isGoogleDocsLost = Boolean(
    hasGoogleDocLiveDocument &&
      (gdocsIntegration?.connected || gdocsIntegration?.disconnected) &&
      !gdocsIntegration.isConnected
  )
  const isGoogleConnectionExpired = isGoogleSheetsLost || isGoogleDocsLost
  const isLiveDocumentsUnavailable = !isGoogleConnectionExpired && hasAccessLostDocument

  const reconnectGoogle = async () => {
    const integration =
      (isGoogleSheetsLost ? gsheetsIntegration : null) ||
      (isGoogleDocsLost ? gdocsIntegration : null)
    if (!integration) return
    if (integration.connected) {
      await nangoReconnect(integration)
    } else {
      await nangoConnect(integration)
    }
  }

  return {
    isGoogleConnectionExpired,
    isLiveDocumentsUnavailable,
    reconnectGoogle,
  }
}
